import RefreshButton from '../../common/components/List/RefreshButton.js'
import {refreshProductList} from './productListFunctions.js'

export default function RefreshProducts() {
  return (
    <li
      className="inline-block margin-right-3 tooltip--top"
      data-hint="Refresh the product list"
    >
      <RefreshButton onClick={() => refreshProductList()} />
    </li>
  )
}
